import { connect } from 'react-redux';

import {
  setRoleNameError,
  optimisticallyUpdateRoleList,
  setRoleRequestBody,
} from '../redux/actions';

import DrawerFooter from './DrawerFooter';

const mapStateToProps = (state) => {
  return {
    role: state.rolesPermissions.role,
    drawerTitle: state.rolesPermissions.drawerTitle,
    drawerOpen: state.rolesPermissions.drawerOpen,
    initialPermissions: state.rolesPermissions.initialPermissions,
    editPermissions: state.rolesPermissions.editPermissions,
    roleRequestBody: state.rolesPermissions.roleRequestBody,
  };
};

const mapDispatchToProps = {
  setRoleNameError,
  optimisticallyUpdateRoleList,
  setRoleRequestBody,
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawerFooter);
